module.exports = __webpack_public_path__ + "images/help_v2/video-play@2x-d1e33aeaf83187477b41161470ed826e.png";